// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__27y7R","content":"ManualTimeModal_content__1vJVU"};